import * as React from "react";
export const EmptyState = (props: React.SVGProps<SVGSVGElement>) => {
	props = {
		...props,
		color: props.color,
	};
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={250}
			height={200}
			fill="none"
			viewBox="0 0 250 200"
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M63 134H154C154.515 134 155.017 133.944 155.5 133.839C155.983 133.944 156.485 134 157 134H209C212.866 134 216 130.866 216 127C216 123.134 212.866 120 209 120H203C199.134 120 196 116.866 196 113C196 109.134 199.134 106 203 106H222C225.866 106 229 102.866 229 99C229 95.134 225.866 92 222 92H200C203.866 92 207 88.866 207 85C207 81.134 203.866 78 200 78H136C139.866 78 143 74.866 143 71C143 67.134 139.866 64 136 64H79C75.134 64 72 67.134 72 71C72 74.866 75.134 78 79 78H39C35.134 78 32 81.134 32 85C32 88.866 35.134 92 39 92H64C67.866 92 71 95.134 71 99C71 102.866 67.866 106 64 106H24C20.134 106 17 109.134 17 113C17 116.866 20.134 120 24 120H63C59.134 120 56 123.134 56 127C56 130.866 59.134 134 63 134ZM226 134C229.866 134 233 130.866 233 127C233 123.134 229.866 120 226 120C222.134 120 219 123.134 219 127C219 130.866 222.134 134 226 134Z"
				fill="#F3F7FF"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M92 140C79.8497 140 70 130.374 70 118.5C70 106.626 79.8497 97 92 97C92.5167 97 93.0292 97.0174 93.537 97.0517C93.1842 95.0878 93 93.0654 93 91C93 72.2223 108.222 57 127 57C141.991 57 154.716 66.702 159.239 80.1695C160.31 80.0575 161.398 80 162.5 80C179.345 80 193 93.4315 193 110C193 125.741 180.675 138.727 165 139.978V140H108.508M103.996 140H97.0314H103.996Z"
				fill="white"
			/>
			<path
				d="M92 141.25C92.6904 141.25 93.25 140.69 93.25 140C93.25 139.31 92.6904 138.75 92 138.75V141.25ZM93.537 97.0517L93.4529 98.2988L95.0504 98.4066L94.7673 96.8306L93.537 97.0517ZM159.239 80.1695L158.054 80.5674L158.372 81.5169L159.369 81.4127L159.239 80.1695ZM165 139.978L164.901 138.732L163.75 138.824V139.978H165ZM165 140V141.25H166.25V140H165ZM108.508 138.75C107.817 138.75 107.258 139.31 107.258 140C107.258 140.69 107.817 141.25 108.508 141.25V138.75ZM92 138.75C80.5128 138.75 71.25 129.657 71.25 118.5H68.75C68.75 131.091 79.1866 141.25 92 141.25V138.75ZM71.25 118.5C71.25 107.343 80.5128 98.25 92 98.25V95.75C79.1866 95.75 68.75 105.909 68.75 118.5H71.25ZM92 98.25C92.4886 98.25 92.9731 98.2665 93.4529 98.2988L93.6211 95.8045C93.0853 95.7684 92.5448 95.75 92 95.75V98.25ZM94.7673 96.8306C94.4275 94.9394 94.25 92.991 94.25 91H91.75C91.75 93.1399 91.9408 95.2362 92.3067 97.2727L94.7673 96.8306ZM94.25 91C94.25 72.9127 108.913 58.25 127 58.25V55.75C107.532 55.75 91.75 71.532 91.75 91H94.25ZM127 58.25C141.438 58.25 153.697 67.5936 158.054 80.5674L160.424 79.7716C155.735 65.8104 142.544 55.75 127 55.75V58.25ZM159.369 81.4127C160.397 81.3052 161.442 81.25 162.5 81.25V78.75C161.355 78.75 160.223 78.8097 159.109 78.9263L159.369 81.4127ZM162.5 81.25C178.674 81.25 191.75 94.1412 191.75 110H194.25C194.25 92.7217 180.015 78.75 162.5 78.75V81.25ZM191.75 110C191.75 125.07 179.945 137.532 164.901 138.732L165.099 141.224C181.406 139.923 194.25 126.411 194.25 110H191.75ZM163.75 139.978V140H166.25V139.978H163.75ZM165 138.75H108.508V141.25H165V138.75ZM103.996 138.75H97.0314V141.25H103.996V138.75ZM97.0314 141.25H103.996V138.75H97.0314V141.25Z"
				fill="#1F64E7"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M116.612 64.3426C116.612 96.5657 145.633 123.118 183 126.703C178.317 132.461 171.086 136.367 162.847 136.981V137H95.7431C87.6013 137 74 133.57 74 118.548C74 103.527 84.5742 100.097 95.7431 100.097C96.218 100.097 96.6891 100.112 97.1559 100.141C96.8316 98.4556 96.7746 96.7184 96.6623 94.9474C95.9038 82.9842 101.123 67.907 116.63 63C116.618 63.4473 116.612 63.8944 116.612 64.3426Z"
				fill="#E8F0FE"
			/>
			<path
				d="M137 69C143.509 70.7226 148.648 75.8129 150.44 82.2932"
				stroke="#75A4FE"
				strokeWidth="2.5"
				strokeLinecap="round"
			/>
			<path
				d="M108 101.5C108 105.09 111.134 108 115 108C118.866 108 122 105.09 122 101.5"
				stroke="#1F64E7"
				strokeWidth="2.5"
				strokeLinecap="round"
			/>
			<path
				d="M137 101.5C137 105.09 140.134 108 144 108C147.866 108 151 105.09 151 101.5"
				stroke="#1F64E7"
				strokeWidth="2.5"
				strokeLinecap="round"
			/>
			<path
				d="M122 120H136.5"
				stroke="#1F64E7"
				strokeWidth="2.5"
				strokeLinecap="round"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M69.156 60.292H57.21V62.668H65.658L56.506 73.756V76H69.376V73.624H60.004L69.156 62.382V60.292ZM82.568 75.576H73.88V77.304H80.024L73.368 85.368V87H82.728V85.272H75.912L82.568 77.096V75.576Z"
				fill="#75A4FE"
			/>
		</svg>
	);
};
